import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const controlGroupDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createControlGroup',
        popover: {
          title: 'Create Control Group',
          description:
            'Click here to create a new control group. Control groups allow you to organize and manage related controls systematically.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.downloadFiles',
        popover: {
          title: 'Download Files',
          description:
            'Use this option to download relevant files associated with the control group. This can include reports, templates, or other documents.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createControlTemplate',
        popover: {
          title: 'Create Control Template',
          description:
            'Create a new control template that can be applied across multiple control groups. Templates ensure consistency in control management.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.uploadCsvFile',
        popover: {
          title: 'Upload CSV File',
          description:
            'Upload a CSV file to import control data into the system. This is useful for bulk importing controls or updating existing data.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createControlGroupSidebar',
        popover: {
          title: 'Control Group Sidebar',
          description:
            'This sidebar provides quick access to control group features and settings. Use it to navigate between different control group actions.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.controlGroupMainTable',
        popover: {
          title: 'Control Group Management Table',
          description:
            'This table displays all control groups currently managed within the system. You can view, edit, or delete control groups from here.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default controlGroupDriverObj;
